// extracted by mini-css-extract-plugin
module.exports = {"contacSchoolView":"ContactSchoolView-module--contacSchoolView--oqgYJ","contactWrapper":"ContactSchoolView-module--contactWrapper--1SLXT"};